import {deliveryTypes} from 'app/constant'
import {FC} from 'react'

type Props = {
  errors: any
  customerId?: any
  isCompliant: boolean
  isComplianceChecked: boolean
  orderDeliveryMethod: string
}

const Errors: FC<Props> = ({
  errors,
  isCompliant,
  isComplianceChecked,
  customerId,
  orderDeliveryMethod,
}) => {
  if (errors && errors.length) {
    return (
      <div className='d-flex flex-column'>
        {/* {customerId && orderDeliveryMethod === deliveryTypes.ship && (
          <div className='fv-plugins-message-container invalid-feedback text-start pt-0'>
            <i className='bi bi-exclamation-circle-fill text-danger me-2'></i>
            <span> Can not ship to this address</span>
          </div>
        )} */}
        {errors.map((error: any, index: any) => (
          <div className='mb-2'>
            <div
              className='fv-plugins-message-container invalid-feedback text-start pt-0'
              key={index}
            >
              <i className='bi bi-exclamation-circle-fill text-danger me-2'></i>
              <span role='alert'>{error.message}</span>
            </div>
            <div className='ms-10 mt-1 text-danger fs-7 fw-bold'>
              <span>{error.description}</span>
            </div>
          </div>
        ))}
      </div>
    )
  }
  if (!isCompliant && isComplianceChecked) {
    return (
      <div className='fv-plugins-message-container invalid-feedback text-start pt-0'>
        <i className='bi bi-exclamation-circle-fill text-danger me-2'></i>
        <span>Order is not compliant </span>
      </div>
    )
  }
  return null
}
export default Errors
